import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard__view-top" }
const _hoisted_2 = { class: "dashboard__view-reference" }
const _hoisted_3 = { class: "dashboard__popup-close" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "p-d-flex p-flex-column p-pb-5"
}
const _hoisted_7 = { class: "dashboard__view" }
const _hoisted_8 = { class: "dashboard__view-top" }
const _hoisted_9 = { class: "dashboard__view-reference" }
const _hoisted_10 = { class: "dashboard__view-date" }
const _hoisted_11 = { class: "dashboard__view-id" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "ID:", -1)
const _hoisted_13 = { class: "dashboard__view-vin" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "VIN:", -1)
const _hoisted_15 = { class: "dashboard__view-center" }
const _hoisted_16 = { class: "dashboard__carInfo-item" }
const _hoisted_17 = {
  class: "dashboard__carInfo-img",
  style: {
                                    backgroundSize: 'cover',
                                }
}
const _hoisted_18 = { class: "dashboard__carInfo-info" }
const _hoisted_19 = { class: "dashboard__carInfo-name" }
const _hoisted_20 = { class: "dashboard__carInfo-desc" }
const _hoisted_21 = { class: "dashboard__carInfo-price" }
const _hoisted_22 = { class: "dashboard__bold" }
const _hoisted_23 = { class: "dashboard__normal" }
const _hoisted_24 = { class: "dashboard__view-bottom" }
const _hoisted_25 = { class: "documents" }
const _hoisted_26 = { class: "documents__title" }
const _hoisted_27 = { class: "documents__items" }
const _hoisted_28 = { class: "documents__item-left" }
const _hoisted_29 = {
  class: "sprite-icon documents__icon",
  width: "16",
  height: "16"
}
const _hoisted_30 = ["xlink:href"]
const _hoisted_31 = { class: "documents__name" }
const _hoisted_32 = { class: "documents__item-right" }
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon documents__icon",
  width: "15",
  height: "10"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#eye-2" })
], -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon documents__icon",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#download" })
], -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_p_scrollpanel = _resolveComponent("p-scrollpanel")!
  const _component_p_sidebar = _resolveComponent("p-sidebar")!
  const _directive_app_fast_gallery = _resolveDirective("app-fast-gallery")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_p_sidebar, {
        key: 0,
        visible: _ctx.show,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
        "show-close-icon": true,
        position: "right",
        class: "c-documents-popup"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("strong", null, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.documents" })
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "dashboard__popup-closeBtn",
                type: "button",
                onClick: _cache[0] || (_cache[0] = () => (_ctx.show = false))
              }, _hoisted_5)
            ])
          ]),
          _createVNode(_component_p_scrollpanel, { class: "c-documents-popup--sidebar-items" }, {
            default: _withCtx(() => [
              (_ctx.orderCarDocuments?.documents)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.orderReference" }),
                            _createTextVNode(" : ")
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.orderCarDocuments.order_reference), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.orderDate" }),
                            _createTextVNode(" : ")
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.orderCarDocuments.order_date)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.orderCarDocuments.car.id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(_ctx.orderCarDocuments.car.vin), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [
                            [_directive_app_fast_gallery, {
                                    images: _ctx.orderCarDocuments.car.images,
                                }]
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.orderCarDocuments.car.title), 1),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.orderCarDocuments.car.description), 1),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, [
                                _createVNode(_component_app_format_currency, {
                                  value: _ctx.orderCarDocuments.car.total,
                                  currency: _ctx.orderCarDocuments.car.currency
                                }, null, 8, ["value", "currency"])
                              ]),
                              _createElementVNode("span", _hoisted_23, [
                                _createTextVNode(" * "),
                                _createVNode(_component_i18n_t, { keypath: "myOrders.exclusiveVat" })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("p", _hoisted_26, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.documents" })
                          ]),
                          _createElementVNode("ul", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderCarDocuments.documents, (doc) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: doc.name,
                                class: "documents__item"
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                                    _createElementVNode("use", {
                                      "xlink:href": `/img/sprite.svg#${doc.file_type}`
                                    }, null, 8, _hoisted_30)
                                  ])),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("span", null, _toDisplayString(doc.name), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("a", {
                                    class: "documents__view",
                                    href: doc.url
                                  }, _hoisted_35, 8, _hoisted_33),
                                  _createElementVNode("a", {
                                    class: "documents__download",
                                    href: doc.url,
                                    download: ""
                                  }, _hoisted_38, 8, _hoisted_36)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}